import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/packages/gatsby-theme-fuegodocs/src/components/Layout/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ResourcesList = makeShortcode("ResourcesList");
const ResourceLink = makeShortcode("ResourceLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The Heading component is a typography component used to display text in different sizes and formats.`}</p>
    <p>{`Fuegokit's Heading component renders an html `}<inlineCode parentName="p">{`h2`}</inlineCode>{` tag with the "h800" variant styles applied by default, including color.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop can be provided a value to over-ride the component styles.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Heading as="h3" variant="h700">
  Make it, and make it better
</Heading>
`}</code></pre>
    <p>{`Heading variants `}<inlineCode parentName="p">{`h900`}</inlineCode>{` - `}<inlineCode parentName="p">{`h100`}</inlineCode>{` are available.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Heading variant="h900">
  Make it, and make it better
</Heading>
<Heading variant="h800">
  Make it, and make it better
</Heading>
<Heading variant="h700">
  Make it, and make it better
</Heading>
<Heading variant="h600">
  Make it, and make it better
</Heading>
<Heading variant="h500">
  Make it, and make it better
</Heading>
<Heading variant="h400">
  Make it, and make it better
</Heading>
<Heading variant="h300">
  Make it, and make it better
</Heading>
<Heading variant="h200">
  Make it, and make it better
</Heading>
<Heading variant="h100">
  Make it, and make it better
</Heading>
`}</code></pre>
    <p>{`Heading levels `}<inlineCode parentName="p">{`h1`}</inlineCode>{` - `}<inlineCode parentName="p">{`h6`}</inlineCode>{` are available; by default, `}<inlineCode parentName="p">{`h800`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Heading as="h1" >
  Make it, and make it better
</Heading>
<Heading as="h2" >
  Make it, and make it better
</Heading>
<Heading as="h3" >
  Make it, and make it better
</Heading>
<Heading as="h4" >
  Make it, and make it better
</Heading>
<Heading as="h5" >
  Make it, and make it better
</Heading>
<Heading as="h6" >
  Make it, and make it better
</Heading>

`}</code></pre>
    <p>{`When passing a semantic element, it should be done in a way that is consistent with the component's
intended use, such as cases where accessibility will be improved by using semantically appropriate HTML elements.`}</p>
    <p>{`Heading levels available through the `}<inlineCode parentName="p">{`level`}</inlineCode>{` prop that adhere to the product experience spec in the host environment.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Please reference the `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/tutorials/page-structure/headings/"
      }}>{`w3 recommendations for headings`}</a>{`
to ensure your headings provide an accessible experience for screen readers.`}</p>
    <h2>{`Margin`}</h2>
    <p>{`The Heading component does not render margin by default.`}</p>
    <p>{`Margin breaks encapsulation and makes reusability harder;
good components should be usable in any context or layout in surprising and hard to manage ways.`}</p>
    <p>{`However, vertical space is often called for above a Header in both long-form, text-based layouts and in the product environment UI.`}</p>
    <p>{`Prefer `}<a parentName="p" {...{
        "href": "/react/components/spacer"
      }}><inlineCode parentName="a">{`<Spacer>`}</inlineCode></a>{` in these cases.`}</p>
    <h2>{`See also`}</h2>
    <ResourcesList mdxType="ResourcesList">
  <ResourceLink href={`/primitives/link`} mdxType="ResourceLink">Link</ResourceLink>
  <ResourceLink href={`/primitives/text`} mdxType="ResourceLink">Text</ResourceLink>
  <ResourceLink href={`/primitives/spacer`} mdxType="ResourceLink">Spacer</ResourceLink>
    </ResourcesList>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      